import { FormControl, FormLabel, Typography, TextField as MuiTextField } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';

interface TextFieldProps {
  label: string;
  disabled: boolean;
  value: string;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  name: string;
  readOnly: boolean;
}

export const TextField = ({ label, disabled, value, onChange, error, name, readOnly }: TextFieldProps) => {
  return (
    <>
      <FormControl fullWidth size="small" data-cy-field-type="text">
        <FormLabel id={`${name}-label`}>{label}</FormLabel>
        <MuiTextField
          size="small"
          aria-labelledby={`${name}-label`}
          value={value}
          error={!!error}
          disabled={disabled}
          name={name}
          onChange={(event) => onChange(event.target.value)}
          inputProps={{ readOnly }}
        />
      </FormControl>
      {error ? <Typography color="error">{error!.message as string}</Typography> : <br />}
    </>
  );
};

export default TextField;
